import { render } from "./myProfile.vue?vue&type=template&id=1f600fa1&scoped=true"
import script from "./myProfile.vue?vue&type=script&lang=js"
export * from "./myProfile.vue?vue&type=script&lang=js"

import "./myProfile.vue?vue&type=style&index=0&id=1f600fa1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f600fa1"]])

export default __exports__